import cssLang from "highlight.js/lib/languages/css";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import xml from "highlight.js/lib/languages/xml";
import { createLowlight } from "lowlight";

/**
 * Shared highlighting kit for the Studio code pane.
 *
 * lowlight = the same highlight.js grammars + `hljs-*` token classes that
 * chat's rehype-highlight emits, so the `index.css` token palette applies
 * unchanged. Registered grammars cover the studio text surface only.
 */
export const lowlight = createLowlight({ css: cssLang, javascript, json, xml });

/** Extension → registered grammar. Entry is always HTML today; the other text
 * types ride along for per-file viewing. */
const LANGUAGE_BY_EXTENSION: Record<string, string> = {
  html: "xml",
  htm: "xml",
  svg: "xml",
  css: "css",
  js: "javascript",
  mjs: "javascript",
  json: "json",
};

/** Sources above this length render un-highlighted: highlight.js walks the
 * whole string on the render thread, and STUDIO_MAX_FILE_BYTES (5 MiB) is far
 * past where that stays imperceptible. */
export const MAX_HIGHLIGHT_CHARS = 200_000;

export function languageForFile(filePath: string): string | null {
  const dot = filePath.lastIndexOf(".");
  if (dot === -1) return null;
  return LANGUAGE_BY_EXTENSION[filePath.slice(dot + 1).toLowerCase()] ?? null;
}
